var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconReset = function SvgIconReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M7 3.65c-.57 0-1.088.091-1.56.233a.437.437 0 1 1-.251-.839A6.282 6.282 0 0 1 7 2.775a5.494 5.494 0 0 1 5.495 5.495A5.494 5.494 0 0 1 7 13.765a5.494 5.494 0 0 1-4.57-8.55.437.437 0 1 1 .728.486 4.62 4.62 0 0 0-.778 2.57A4.619 4.619 0 0 0 7 12.89a4.619 4.619 0 0 0 4.62-4.62A4.619 4.619 0 0 0 7 3.65Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.564 1.337a.438.438 0 0 1 .043.617L4.92 3.891a.437.437 0 1 1-.66-.575L5.947 1.38a.438.438 0 0 1 .617-.043Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M4.237 3.345a.437.437 0 0 1 .612-.095l1.966 1.435a.438.438 0 0 1-.516.707L4.333 3.957a.438.438 0 0 1-.096-.612Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconReset;